import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import clsx from 'clsx';
import Plus from '../utils/icon/plus.svg'
import ColumnInner from './column-inner';
import { ANIMATION_DURATION, functionDelay, generateIngredientsList, toggleDocumentScroll } from './utils';

const ColumnComponentMobile = ({
  data,
  index,
  isActive,
  setActiveItem,
}) => {
  const {
    title,
    ingredients,
    description,
    inner_cta_bg: buyButtonBg,
    inner_cta_text: buyButtonText,
    inner_cta_link_url: ctaLinkUrl,
    lifestyle_images: lifestyleImages,
    is_lifestyle_image_bordered: isLifestyleImageBordered,
    lifestyle_image_border_color: lifestyleImageBorderColor,
    text_color: textColor,
    text_align_mobile: textAlignMobile,
    image_bg: imageBgDesktop,
    image_bg_mobile: imageBgMobile,
    image_bg_mobile_modal: imageBgMobileModal,
    video_desktop: videoDesktop,
    video_mobile: videoMobile,
    product_list: productsList,
  } = data;

  const [zIndexClass, setZIndexClass] = useState('-z-10');

  useEffect(
    () => {
      if (isActive) {
        setZIndexClass('z-[20]')
        toggleDocumentScroll(false)
        return
      }
      functionDelay({ fn: setZIndexClass, value: '-z-10' })
      toggleDocumentScroll(true)
      },
    [isActive],
  );

  const innerMediaData = {
    imageBgDesktop,
    imageBgMobile,
    imageBgMobileModal,
    videoDesktop,
    videoMobile,
    lifestyleImages
  };
  const innerContentData = {
    title,
    productsList,
    buyButtonBg,
    buyButtonText,
    description,
    ctaLinkUrl
  };

  const handleColumnClick = (e) => {
    const elem = e.target;
    const { itemIndex } = elem.closest('[data-item-index]').dataset;
    setActiveItem(Number(itemIndex));
  };

  const handleColumnClose = (e) => {
    e.stopPropagation();
    setActiveItem(Number(-1));
  };

  return (
    <column
      className={clsx(
        'relative flex justify-between flex-1 min-h-[135px]',
        'py-[24px] pl-[20px] pr-[5px]',
        `${isActive ? 'is-active' : ''}`,
        'bg-cover bg-center bg-no-repeat',
      )}
      style={`color: ${textColor}; background-image: url('${
        imageBgMobile || imageBgDesktop
      }')`}
      data-item-index={index}
      onClick={(e) => handleColumnClick(e)}
    >
      <column-content className='flex flex-col flex-1 h-full'
      >
        <column-title className="pb-[12px] v-h5 relative z-[4]">
          {title}
        </column-title>
        <column-desc-and-cta className={clsx('relative z-[4] v-eyebrow-sm')}>
          {generateIngredientsList(ingredients)}
        </column-desc-and-cta>
      </column-content>
      <column-mobile-cta className="relative z-[4] flex align-center">
        <button className="p-[12px]">
          <Plus />
        </button>
      </column-mobile-cta>
      <column-modal
        className={clsx(
          `fixed inset-0 overflow-scroll w-[100dvw] opacity-0`,
          `transition-opacity duration-${ANIMATION_DURATION} ease-in-out`,
          `text-${textAlignMobile}`,
          `${zIndexClass}`,
          `[.is-active_&]:opacity-100`,
        )}
      >
        <ColumnInner
          mediaData={innerMediaData}
          contentData={innerContentData}
          index={index}
          handleColumnClose={handleColumnClose}
          isMobile={true}
          isOpened={isActive}
          isLifestyleImageBordered={isLifestyleImageBordered}
          lifestyleImageBorderColor={lifestyleImageBorderColor}
        />
      </column-modal>
    </column>
  );
};

export default ColumnComponentMobile;